import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const categoryRoutes: RouteRecordRaw[] = [
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/modules/categories/views/CategoryListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
